import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Badge } from 'react-bootstrap';
import { UilStopwatch } from '@iconscout/react-unicons';

const SparkTesterStatus = ({ sparkStatus }) => {
  console.log('SPARK TESTER', sparkStatus);

  return (
    <Badge
      variant="phoenix"
      bg={sparkStatus ? 'success' : 'danger'} // Green for ON, Red for OFF
      iconPosition="end"
      icon={<UilStopwatch size={12} className="ms-1" />}
    >
      {sparkStatus ? 'SPARK TESTER: ON' : 'SPARK TESTER: OFF'}
    </Badge>
  );
};

export default SparkTesterStatus;
